import { Expose, Type } from "class-transformer";

import { Dependent } from "src/shared/models/dependent.model";
import { PgaPolicy } from "src/shared/models/pga-policy.model";

export class HealthPolicy extends PgaPolicy {
    @Expose() codPlan = "";
    @Expose() revPlan = "";
    @Expose() status = "";
    @Expose()
    @Type(() => Dependent)
    dependents?: Dependent[];
    @Expose() digital = true;
}
